import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/page/login/index';
import MainRoot from '@/page/main/root';
import MainIndex from '@/page/main/index/index';
import MainCaseList from '@/page/main/case/caseList'; // 案件列表
import MainRepayList from '@/page/main/repay/list'; // 还款列表
import MainReplyList from '@/page/main/reply/list'; // 回复列表
import MainBatchOverviewList from '@/page/main/batchOverview/list'; // 批次总览
import MainCaseDetail from '@/page/main/case/detail'; // 案件详情
import MainCollectionReport from '@/page/main/collection/report/index'; // 作业报告
import MainCollectionEngine from '@/page/main/collection/engine/index'; // 策略引擎
import MainStrategySettlement from '@/page/main/collection/settlement/index'; // 策略结算
import MainCollectionCondition from '@/page/main/collection/condition/index'; // 条件路由
import MainConditionGroup from '@/page/main/collection/condition/group/index'; // 条件路由配置
import MainConditionDetail from '@/page/main/collection/condition/detail/index'; // 条件路由规则
import MainConditionScene from '@/page/main/collection/condition/scene/index'; // 对话场景路由
import MainConditionSceneRelation from '@/page/main/collection/condition/scene/relation/index'; // 对话场景路由配置
import MainConditionSceneDetail from '@/page/main/collection/condition/scene/detail/index'; // 对话场景路由规则
import MainConditionTemplate from '@/page/main/collection/condition/template/index'; // 场景模板路由
import MainConditionTemplateRelation from '@/page/main/collection/condition/template/relation/index'; // 场景模板路由配置
import MainConditionTemplateDetail from '@/page/main/collection/condition/template/detail/index'; // 场景模板路由规则
import MainIntention from '@/page/main/collection/intention/index'; // 意图包配置
import MainIntentionConf from '@/page/main/collection/intention/conf/conf_index'; // 意图包配置
import MainIntentionDetail from '@/page/main/collection/intention/detail/detail_index'; // 意图配置
import MainIntentionCon from '@/page/main/collection/intention/condition/con_index'; // 意图规则配置
import MainDecisionsConfig from '@/page/main/decisions/config'; // 决策引擎
import MainCallIndex from '@/page/main/call/default/index'; // 呼叫平台-默认配置
import MainMessageList from '@/page/main/message/list'; // 发送列表
import MainCompanyMessageList from '@/page/main/company/index'; // 公司信息
import MainPhoneBlacklist from '@/page/main/phoneBlacklist/list'; // 黑名单
import MainFileProcess from '@/page/main/fileProcess/list'; // 文件处理
import MainRecorder from '@/page/main/recorder/index'; // 录音员配置
import MainCostCalculation from '@/page/main/costCalculation/index'; // 费用核算
import MainAccountList from '@/page/main/account/list'; // 账号管理
import MainPermissionList from '@/page/main/permission/list'; // 权限配置
import MainNewCallPlatform from '@/page/main/call/custom/index'; // 呼叫平台-自定义配置
import MainCallService from '@/page/main/call/service/index'; // 呼叫平台-服务配置
import MainCallServiceBox from '@/page/main/call/serviceBox/index'; // 呼叫平台-资源组维护
import MainSbcGroup from '@/page/main/call/sbcGroup/index'; // 呼叫平台-SBC维护
import MainTestEngine from '@/page/main/test_engine/index'; // 测试引擎
import MainUserCenter from '@/page/main/userCenter/index'; // 测试引擎
import MainMarkLabel from '@/page/main/algCorpus/robotMarkLabel'; // 打标页面
import MainKeyWord from '@/page/main/algCorpus/robotKeyWord'; // 关键词表
import MainInteractiveQuery from '@/page/main/algCorpus/robotInteractiveQuery'; // 关键词表
import MainMarkLabelAssignment from '@/page/main/algCorpus/robotMarkLabelAssignment'; // 打标分配
import MainMonitor from '@/page/main/monitor/robotMonitor'; // 实时监控
import MainAlarmSetting from '@/page/main/monitor/robotAlarmSetting'; // 报警设置
import Ztree from '@/page/main/ztree/treeDemo'; // 案件列表
import MainLuceneSetting from '@/page/main/algCorpus/robotLuceneSetting'; // 敏感词管理
import Voice from '@/page/main/telephone/voice'; // 录音测试
import MainJobList from '@/page/main/job/list'; // 定时任务
import MainDictTypeList from '@/page/main/dict/typeList';
import MainDictList from '@/page/main/dict/list';
import OpenCaseInfo from '@/page/main/case/openCaseInfo'; // 案件详情
import MainSystemConfig from '@/page/main/system/config'; // 跟进配置(营销)
import MainSystemCollectConfig from '@/page/main/system/collectConfig'; // 跟进配置(催收)
import MainSystemPushRecord from '@/page/main/system/pushRecord'; // 推送记录
import MainKeywordAudio from '@/page/main/system/keywordAudio/filed_voice'; // 关键字音频
import MainTagPools from '@/page/main/tagpools/index'; // 标签三级管理

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: '登录页面',
      component: Login
    },
    {
      path: '/main',
      component: MainRoot,
      children: [
        { path: '', name: '主页', component: MainIndex },
        { path: 'case/caseList', name: '案件列表', component: MainCaseList },
        { path: 'repay/list', name: '还款列表', component: MainRepayList },
        { path: 'reply/list', name: '回复列表', component: MainReplyList },
        { path: 'batchOverview/list', name: '批次总览', component: MainBatchOverviewList },
        { path: 'case/detail/:id', name: '案件详情', component: MainCaseDetail },
        { path: 'collection/report', name: '作业报告', component: MainCollectionReport },
        { path: 'collection/engine', name: '策略引擎', component: MainCollectionEngine },
        { path: 'collection/settlement', name: '策略结算', component: MainStrategySettlement },
        { path: 'collection/condition', name: '条件路由', component: MainCollectionCondition },
        { path: 'collection/condition/group/:companyId/:routeConfId', name: '条件路由配置', component: MainConditionGroup },
        { path: 'collection/condition/detail/:companyId/:groupRelationId/:routeConfName/:routeGroupName', name: '条件路由规则', component: MainConditionDetail },
        { path: 'collection/condition/scene', name: '对话场景路由', component: MainConditionScene },
        { path: 'collection/condition/scene/relation/:companyId/:groupId/:routeConfId', name: '对话场景路由配置', component: MainConditionSceneRelation },
        { path: 'collection/condition/scene/detail/:companyId/:relationId', name: '对话场景路由规则', component: MainConditionSceneDetail },
        { path: 'collection/condition/template', name: '场景模版路由', component: MainConditionTemplate },
        { path: 'collection/condition/template/relation/:companyId/:groupId/:routeConfId', name: '场景模版路由配置', component: MainConditionTemplateRelation },
        { path: 'collection/condition/template/detail/:companyId/:relationId', name: '场景模版路由规则', component: MainConditionTemplateDetail },
        { path: 'collection/intention', name: '意图信息1', component: MainIntention },
        { path: 'collection/intention/conf', name: '意图信息', component: MainIntentionConf },
        { path: 'collection/intention/detail/:confId/:confName', name: '意图配置', component: MainIntentionDetail },
        { path: 'collection/intention/condition/:detailId/:confName/:intention1Name/:intention2Name', name: '意图规则配置', component: MainIntentionCon },
        { path: 'decisions/config', name: '决策引擎', component: MainDecisionsConfig },
        { path: 'call/default', name: '呼叫平台-默认配置', component: MainCallIndex },
        { path: 'message/list', name: '发送列表', component: MainMessageList },
        { path: 'company', name: '公司信息', component: MainCompanyMessageList },
        { path: 'phoneBlacklist', name: '黑名单', component: MainPhoneBlacklist },
        { path: 'fileProcess', name: '文件处理', component: MainFileProcess },
        { path: 'recorder', name: '录音员配置', component: MainRecorder },
        { path: 'costCalculation', name: '费用核算', component: MainCostCalculation },
        { path: 'account/list', name: '账号管理', component: MainAccountList },
        { path: 'telephone/voice', name: '录音测试', component: Voice },
        { path: 'permission/list', name: '权限配置', component: MainPermissionList },
        { path: 'call/custom', name: '呼叫平台-自定义配置', component: MainNewCallPlatform },
        { path: 'call/service', name: '呼叫平台-服务配置', component: MainCallService },
        { path: 'call/serviceBox', name: '呼叫平台-资源组维护', component: MainCallServiceBox },
        { path: 'call/sbcGroup', name: '呼叫平台-SBC资源组维护', component: MainSbcGroup },
        { path: 'test_engine', name: '测试引擎', component: MainTestEngine },
        { path: 'userCenter', name: '个人中心', component: MainUserCenter },
        { path: 'algCorpus/robotMarkLabel', name: '打标页面', component: MainMarkLabel },
        { path: 'algCorpus/robotKeyWord', name: '关键词表', component: MainKeyWord },
        { path: 'algCorpus/robotInteractiveQuery', name: '交互查询', component: MainInteractiveQuery },
        { path: 'algCorpus/robotMarkLabelAssignment', name: '打标分配', component: MainMarkLabelAssignment },
        { path: 'monitor/robotAlarmSetting', name: '报警设置', component: MainAlarmSetting },
        { path: 'system/config', name: '跟进配置(营销)', component: MainSystemConfig },
        { path: 'system/collectConfig', name: '跟进配置(催收)', component: MainSystemCollectConfig },
        { path: 'ztree/treeDemo', name: 'ztre测试', component: Ztree },
        { path: 'algCorpus/robotLuceneSetting', name: '敏感词管理', component: MainLuceneSetting },
        { path: 'job/list', name: '定时任务', component: MainJobList },
        { path: 'dict/listType', name: '字典类型管理', component: MainDictTypeList },
        { path: 'dict/list/:modelType', name: '字典管理', component: MainDictList },
        { path: 'system/pushRecord', name: '推送记录', component: MainSystemPushRecord },
        { path: 'system/keywordAudio', name: '关键字音频', component: MainKeywordAudio },
        { path: 'tagpools', name: '标签池管理', component: MainTagPools }
      ]
    },
    { path: '/monitor/robotMonitor', name: '实时监控', component: MainMonitor },
    { path: '/case/openCaseInfo/:companyId/:id', name: '案件详情', component: OpenCaseInfo }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js